import { render } from "./CollectionOrderManagement.html?vue&type=template&id=6aace852&scoped=true"
import script from "./CollectionOrderManagement.js?vue&type=script&lang=js"
export * from "./CollectionOrderManagement.js?vue&type=script&lang=js"

import "./CollectionOrderManagement.css?vue&type=style&index=0&id=6aace852&scoped=true&lang=css"

import exportComponent from "/Users/blakegilbert/Documents/Projects/ShipTech/st-web-petro-network-admin-portal/src/ST.PetroNetworkAdmin.Web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6aace852"]])

export default __exports__